module.exports = __webpack_public_path__ + "img/daffodil-small-graphic.0249956f.svg";